import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../framework/customStore";
import { Grid, Box } from "@mui/material";
import { VehicleTripSegment } from "../../../models/vehicle/vehicleTripSegment";
import { Base } from "../../../framework/base";
import { BoldText, Text } from "../styledComponents";
import { StopIcon, MovingIcon, RouteCardDriverIcon } from "./customIcons";

interface VehicleRouteCardContentProps {
    tripSegment: VehicleTripSegment;
    stopIndex: number;
}

const VehicleRouteCardContent: React.FC<VehicleRouteCardContentProps> = ({ tripSegment, stopIndex }) => {
    const { t } = useTranslation();

    const {
        state,
        startTime,
        endTime,
        durationMinutes,
        distance,
        streetAddress,
        positions
    } = tripSegment;
    const employees = useAppSelector((state) => state.employees.employees);

    const driverId = positions[0]?.driverId;
    const driver = employees.find(employee => employee.id === driverId)?.fullName;

    const formatTime = (time: string | undefined) => {
        if (!time) return "";
        return Base.dayjsToTimeStr(time).replace(".", ":");
    };
    const formatDuration = (minutes: number) => {
        const { hours, minutes: remainingMinutes } = Base.minutesToHoursAndMinutes(minutes);
        return hours > 0 ? `${hours}h ${remainingMinutes}m` : `${remainingMinutes}m`;
    };

    const effectiveDate = startTime.split("T")[0]; // this should be effectiveDate from workShift

    return (
        <Grid container alignItems="center" spacing={0.75} sx={{ padding: 0.75 }}>
            <Grid item>
                <Box sx={{ marginRight: 1 }}>
                    {state === "Moving" ? <MovingIcon /> : <StopIcon index={stopIndex} />}
                </Box>
            </Grid>
            <Grid item xs>
                <BoldText sx={{ color: "gray !important" }}>
                    {formatTime(startTime)} - {formatTime(endTime)}
                </BoldText>
                {state === "Moving" && (
                    <BoldText sx={{ color: "#000", marginLeft: 1 }}>
                        {`${distance?.toFixed(2)} km`}
                    </BoldText>
                )}
                {state === "Moving" && (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <RouteCardDriverIcon />
                        {driver ? (
                            <a href={`/worktimepage/details/${driverId}/${effectiveDate}`}>
                                <Text variant="body2" sx={{ color: "#426ac6" }}>
                                    {driver}
                                </Text>
                            </a>
                        ) : (
                            <Text variant="body2">
                                {t("monitorView.noDriver")}
                            </Text>
                        )}
                    </Box>
                )}
                {state === "Stopped" && (
                    <Box sx={{ display: "block" }}>
                        <Text variant="body2">
                            {streetAddress}
                        </Text>
                    </Box>
                )}
            </Grid>
            <Grid item>
                <BoldText sx={{ marginLeft: 1, color: "gray !important" }}>
                    {formatDuration(durationMinutes)}
                </BoldText>
            </Grid>
        </Grid>
    );
};

export default VehicleRouteCardContent;